<template>
    <div id="order-info">
        <Content class="content-wrap">
            <div class="title-info" v-show="info.status == '1'">
                <div class="batchNo">预单号：{{info.businessNo}}</div>
                <div class="statusName" :style="{color:checkCls(info.businessStatus)}">{{info.businessStatusName}}</div>
            </div>
            <div class="batchNo-status">
                <div class="status-title">{{info.statusName}}</div>
                <div class="status-text">{{info.tips}}</div>
            </div>
            <div class="info-content">
                <ul class="info-list">
                    <li class="info-item">
                        <div class="item-label">预约海葬时间</div>
                        <div class="item-text">{{info.year}}年{{info.month}}月</div>
                    </li>
                    <li class="info-item">
                        <div class="item-label">参加地点</div>
                        <div class="item-text">{{info.position}}</div>
                    </li>
                    <li class="info-item">
                        <div class="item-label">申请人姓名</div>
                        <div class="item-text">{{info.linkmanName}}</div>
                    </li>
                    <li class="info-item">
                        <div class="item-label">海葬者姓名</div>
                        <div class="item-text">{{info.userNames}}</div>
                    </li>
                    <li class="info-item">
                        <div class="item-label">手机号码</div>
                        <div class="item-text">{{info.mobile}}</div>
                    </li>
                    <li class="info-item">
                        <div class="item-label">参加人数</div>
                        <div class="item-text">{{info.participantNum}}人</div>
                    </li>
                    <li class="info-item" v-show="info.status == '1'">
                        <div class="item-label">活动时间</div>
                        <div class="item-text">{{info.activityDate}}</div>
                    </li>
                    <li class="info-item" v-show="info.status == '1'">
                        <div class="item-label">办理时间</div>
                        <div class="item-text">{{info.handleDate}}</div>
                    </li>
                </ul>
            </div>
        </Content>
<!--        <fx-modal ref="cancelOrder" :title="plugin.modal.cancelOrder.title" @closeModal="closeModal('cancelOrder')" :contentText="plugin.modal.cancelOrder.desc" @ok="confirm" ></fx-modal>-->
    </div>
</template>

<script>
    import  fxModal from '../../components/fx-modal'
    import api from '../../api/api'
    let self;
    export default {
        name: 'orderInfo',
        components: {
            fxModal
        },
        data(){
            return{
                businessId:'',
                info:{
                    linkman:{}
                },
                plugin:{
                    modal:{
                        cancelOrder:{
                            title:'取消预约?',
                            desc:'是否取消预约？'
                        },
                    }
                },
                statusTitle:'',
                statusText:'',
                statusInfo:{
                    '0':{
                        title: '预约待审核中',
                        text: '您已成功提交预约，请等待预约反馈'
                    },
                    '1':{
                        title:'审核通过',
                        text:''
                    },
                    '2':{
                        title:'审核未通过',
                        text: ''
                    }
                }
            }
        },
        computed:{
        },
        watch:{
            'info.status'(status){
                this.statusTitle = this.statusInfo[status].title
                this.statusText = this.statusInfo[status].text
            }
        },
        created(){
            self = this;
        },
        activated(){
            this.businessId = this.$route.params.id
            this.getBusinessInfo()
        },
        methods:{
            checkCls(id) {
                var color = '';
                switch (id) {
                    case '1':
                        color = 'green';
                        break;
                    case '2':
                        color = 'red';
                        break;
                    default:
                        color = '#009DE9'
                }
                return color
            },
            closeModal(key){
                this.$refs[key].hide()
            },
            openModal(key){
                this.$refs[key].open()
            },
            confirm(){
                if(!this.businessId)return
                api.businessCancel(this.businessId).then(res=>{
                    self.$Message.success(`取消成功！`)
                    setTimeout(function () {
                        self.getBusinessInfo()
                    },500)
                }).catch(error=>{
                    self.$Message.error(`取消失败！${error.info}`)
                })
            },
            getBusinessInfo(){
                if(!this.businessId)return
                api.businessInfo({"indexId":this.businessId}).then(res=>{
                    self.info = res
                }).catch(error =>{
                    self.$Message.error(`预约信息获取失败！${error.info}`)
                })
            },
            cancelOrder(){
                this.openModal('cancelOrder')
            }
        }
    }
</script>

<style scoped lang="scss">
    #order-info{
        background-color: #fff;
    }
    .content-wrap{
        max-width: 1024px;
        margin: 20px auto;
        padding: 20px;
        overflow: hidden;
        min-height: 600px;
        max-height: 950px;
        .title{
            font-size: 20px;
            text-align: left;
        }
        .title-info{
            overflow: hidden;
            padding-top: 20px;
            .batchNo{
                float: left;
                font-size: 18px;
            }
            .statusName{
                float: right;
                font-size: 20px;
            }
        }
        .batchNo-status{
            padding: 30px;
            background-color: #3760d0;
            color: #fff;
            font-weight: bold;
            margin-top: 30px;
            .status-title{
                font-size: 24px;
            }
            .status-text{
                font-size: 20px;
                margin-top: 20px;
            }
        }
        .info-content{
            .content-top{
                border-bottom: 1px solid #eee;
                overflow: hidden;
                padding: 30px 0;
                .linkman-name{
                    float: left;
                    font-size: 24px;
                }
                .cancel-btn{
                    float: right;
                    background-color: #3760d0;
                }
            }
        }
        .info-list{
            .info-item{
                overflow: hidden;
                font-size: 18px;
                padding: 20px 0;
                .item-label{
                    float: left;
                    width: 140px;
                    text-align: left;
                    color: #A0A0A0;
                }
                .item-text{
                    float:left;
                }
            }
        }
    }
</style>
